import { TimeRange } from "@/types/time-range";

export function bytesToSize(bytes: number): string {
  const sizes: string[] = ["B", "KB", "MB", "GB", "TB"];
  if (bytes === 0) {
    return "0MB";
  }
  const i: number = Math.floor(Math.log(bytes) / Math.log(1024));
  if (i === 0) {
    return `${bytes}${sizes[i]}`;
  }
  // if GB or greater
  let decimalPoints = 0;
  if (i > 2) {
    decimalPoints = 1;
  }
  return `${(bytes / 1024 ** i).toFixed(decimalPoints)}${sizes[i]}`;
}

export function bytesToPlan(bytes: number): string {
  const MB: number = bytes / (1024 * 1024);
  if (MB >= 1000) {
    const GB: number = MB / 1000;
    return `${GB.toFixed(1)}GB`;
  }
  return `${MB}MB`;
}

export function getWholeFromPrefix(number: number, factor: number) {
  return number * 10 ** factor;
}

export function constToTitle(value: string): string {
  return value.replace(/_/gi, " ").toLowerCase();
}

export function getTimeRange(timeRangeState: TimeRange, timeRange?: TimeRange) {
  const range = timeRange ? timeRange : timeRangeState;

  const endTime = new Date();
  const startTime = new Date();

  switch (range) {
    case TimeRange.LAST_HOUR:
      startTime.setMinutes(endTime.getMinutes() - 71);
      break;
    case TimeRange.LAST_DAY:
      // 1 day, 11 minutes ago
      startTime.setDate(endTime.getDate() - 1);
      startTime.setMinutes(endTime.getMinutes() - 11);
      break;
    case TimeRange.LAST_WEEK:
      startTime.setDate(endTime.getDate() - 7);
      break;
    case TimeRange.LAST_MONTH:
      startTime.setDate(endTime.getDate() - 30);
      break;
  }

  return { startTime, endTime };
}
